import { Button } from '@/components/ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export function PropertyPagination({ page, totalPages, setPage }) {
  if (totalPages <= 1) return null;

  const pageNumbers = [];
  const maxVisible = Math.min(5, totalPages);
  for (let i = 0; i < maxVisible; i++) {
    let pageNum;
    if (totalPages <= 5) {
      pageNum = i;
    } else if (page < 3) {
      pageNum = i;
    } else if (page > totalPages - 4) {
      pageNum = totalPages - 5 + i;
    } else {
      pageNum = page - 2 + i;
    }
    pageNumbers.push(pageNum);
  }

  return (
    <div className="flex items-center justify-center gap-2 mt-12">
      <Button variant="outline" size="sm" onClick={() => setPage(Math.max(0, page - 1))}
        disabled={page === 0} className="border-[#E7E5E4]" data-testid="prev-page-btn">
        <ChevronLeft className="w-4 h-4" />
      </Button>
      <div className="flex items-center gap-1">
        {pageNumbers.map((pageNum) => (
          <Button key={pageNum} variant={page === pageNum ? "default" : "outline"} size="sm"
            onClick={() => setPage(pageNum)} className={page === pageNum ? "bg-[#264639]" : "border-[#E7E5E4]"}>
            {pageNum + 1}
          </Button>
        ))}
      </div>
      <Button variant="outline" size="sm" onClick={() => setPage(Math.min(totalPages - 1, page + 1))}
        disabled={page >= totalPages - 1} className="border-[#E7E5E4]" data-testid="next-page-btn">
        <ChevronRight className="w-4 h-4" />
      </Button>
    </div>
  );
}
